<template>
    <div v-if="showBecame" class="row-became">
        <span>
            <i class="material-icons">error</i>
            <b>{{ 'browsing-platform-as' | lang }} {{$root.user.name}} {{$root.user.surname}}</b>
        </span>
        <div>
            <div v-if="waitingForUnbecomeResponse" class="btn">{{ 'general.loading' | lang }}</div>
            <div v-else @click="goBackToSuperadmin()" class="btn">{{ 'back-to-superadmin' | lang }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "became-indicator",
        computed: {
            showBecame() {
                return !!localStorage.getItem('became');
            }
        },
        data() {
            return {
                waitingForUnbecomeResponse: false,
            }
        },
        methods: {
            unbecomeUser() {
                return this.$http.post("/unbecome", {
                    'token': localStorage.getItem("token")
                })
                .then(response => response)
                .catch(error => error);
            },

            async goBackToSuperadmin() {
                this.waitingForUnbecomeResponse = true;

                const unbecomeResp = await this.unbecomeUser();

                if (unbecomeResp.body.status === 0) {
                    window.location.href = '/logout?redirect=users/login?error=incorrect-token-when-unbecoming';
                    return;
                }

                if (unbecomeResp.body.status === 1) {
                    this.$router.push({path: '/users/unbecome'});
                }

                this.waitingForUnbecomeResponse = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    .row-became {
        padding: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 15px;
        background: $orange;
        color: white;

        i {
            margin-right: 12px;
            font-size: 24px;
        }

        & > span {
            display: flex;
            align-items: center;
        }

        .btn {
            margin-left: 12px;
            border-radius: 3px;
        }
    }
</style>